//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import emojiData from './emoji-data.js'

export default {
    name: 'Emoji',
    data() {
        return {
            emojiData,
            pannels: ['表情', '自然', '物品', '地点', '符号'],
            activeIndex: 0
        }
    },
    computed: {
        emojis() {
            return this.pannels.map(item => {
                return Object.keys(this.emojiData[item])
            })
        }
    },
    methods: {
        changeActive(index) {
            this.activeIndex = index
        },
        getPureName(name) {
            return name.replace(/:/g, '')
        },
        selectItem(emoji) {
            this.$emit('select', emoji)
        }
    }
}
